import type { IProjectRepository } from '../repositories/IProjectRepository.js';
import type { ProjectEntity } from '../entities/ProjectEntity.js';

interface Deps { projectRepository: IProjectRepository; }

export function createGetProjectByIdUseCase({ projectRepository }: Deps) {
  return async function getProjectById(id: string): Promise<ProjectEntity | null> {
    return projectRepository.getById(id);
  };
}
